import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import Moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DataEmptyState from '../../commons/dataemptystate';
import NetworkEmptyState from '../../commons/networkemptystate';
import Loader from '../../commons/loader';
import Services from './services';
import BlogForm from './BlogForm';
import { PaginationTotal } from '../../commons/controls';
import { ProgressButton } from '../../commons/ProgressButton';
import Lib from '../../commons/lib';

import 'moment/locale/hu';
import TimeFormatter from '../../commons/TimeFormatter';
// momentLocalizer(Moment);

class BlogContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',
      // ['FEL', 'MOD']
      formType: 'FEL',
      // DATA
      baseJson: [],
      currentId: undefined,
      torlesId: undefined,

      // MODAL UTILS
      modalForm: false,
      modalDelete: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
    };

  }

  componentDidMount() {
    this.listPost();
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.active !== prevProps.active) {
      if (this.props.active) this.listPost();
    }
  }

  toggleViewModal = () => {
    this.setState(prevState => ({ modalView: !prevState.modalView }));
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }), () => {
      if(!this.state.modalForm){
        this.listPost();
      }
    });
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  listPost = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listPost({}, (err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
            currentId: null,
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleEditClick = (id) => {
    this.setState({
      currentId: id,
    }, () => {
      this.toggleFormModal();
    });
  }

  handleViewClick = (id) => {
    this.setState({
      viewStatus: 'LOAD',
      currentId: id,
    }, () => {
      this.getPostView(id);
      this.toggleViewModal();
    });
  }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      this.toggleDeleteModal();
    });
  }

  getPostView = (id) => {
    this.setState({
      viewStatus: 'LOAD',
    }, () => {
      Services.viewPost(id, (err, res) => {
        if (!err) {
          this.setState({
            viewObj: res[0],
            viewStatus: 'DATA',
          });
        } else {
          this.setState({
            viewStatus: 'NETW'
          });
        }
      });
    });
  }

  deletePost = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deletePost(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listPost();
        this.props.globals.addSuccess('Bejegyzés törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  tableIconFormatter = (cell, row) => {
    return (
      <div>
        <React.Fragment>
          <React.Fragment> 
            <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekint'} onClick={() => this.handleViewClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'megtekint'} delay={50}>
              {'Megtekintés'}
            </UncontrolledTooltip>
          </React.Fragment> 
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + '-szerkesztes'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + '-szerkesztes'} delay={50}>
              {'Bejegyzés módosítása'}
            </UncontrolledTooltip>
          </React.Fragment>
          <React.Fragment>
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + '-torles'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + '-torles'} delay={50}>
              {'Bejegyzés törlése'}
            </UncontrolledTooltip>
          </React.Fragment>
        </React.Fragment>
      </div>
    );
  }

  dateToTimezone = (date) => {
    if (!date || date === '') return null;
    return TimeFormatter.formatIso(date);
  }

  timezoneToDate = (date) => {
    if (!date || date === '') return null;
    return TimeFormatter.format(date, "lll");
  }

  renderView = () => {
    const {
      viewObj
    } = this.state;

    return (
      <div>
        <h6>Bejegyzés:</h6>
        <b>Cím: </b>
        {viewObj && viewObj.cim}
        <br />
        <b>Bejegyzés időpontja: </b>
        {viewObj && viewObj.publikalas && this.timezoneToDate(viewObj.publikalas)}
        <br />
        <b>Publikálás kezdete: </b>
        {viewObj && viewObj.kezdete && this.timezoneToDate(viewObj.kezdete)}
        <br />
        <b>Publikálás vége: </b>
        {viewObj && viewObj.vege && this.timezoneToDate(viewObj.vege)}
        <br />
        <b>Elérhetőség kezdete: </b>
        {viewObj && viewObj.elerhetosegKezdete  && this.timezoneToDate(viewObj.elerhetosegKezdete)}
        <br />
        <b>Elérhetőség vége: </b>
        {viewObj && viewObj.elerhetosegVege  && this.timezoneToDate(viewObj.elerhetosegVege)}
        <br />
        <b>Összefoglaló: </b>
        {viewObj && viewObj.tartalomSum}
        <br />
        <b>Helyszínek: </b>
        {viewObj && viewObj.helyszinek}
        <br />
        <b>Url: </b>
        <ul>
          {viewObj && viewObj.urls && viewObj.urls.map( url => <li><a  target="_blank" href={url}> {url} </a></li>)}
        </ul>
        <br />
      </div>
    );
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const columns = [
      {
        dataField: 'cim',
        text: 'Cím',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'publikalas',
        text: 'Bejegyzés időpontja',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true,
        formatter: cell => cell && TimeFormatter.formatDateTime(cell)
      },
      {
        dataField: 'publikalasInterval',
        text: 'Publikálás',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'elerhetosegInterval',
        text: 'Elérhetőség',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'helyszinek',
        text: 'Helyszínek',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true,
        formatter: cell => cell && cell.map(h => h.nev).join(", "),
        filterValue: cell => cell && cell.map(h => h.nev).join(", ")
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.tableIconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          rowStyle={(row) => (row && row.status && row.status === 'ALLAPOT') ? {color: 'red'}: {}}
          columns={columns}
          wrapperClasses="table-responsive"
          classes="table-scroll"
          headerClasses="table-th"
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  renderTableView = () => {
    return(
      <div className="col-md-12">
        {{
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Vigyél fel új tételt!"
          />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => this.listPost()}
          />),
          TABL: (this.renderTable())
        }[this.state.tableStatus]}
      </div>
    );
  }


  renderModals = () => {
    return (
      <React.Fragment>
        <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.deletePost()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalView} toggle={this.toggleViewModal} backdrop="static">
          <ModalHeader>
            {'Megtekintés'}
          </ModalHeader>
          <ModalBody>
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => this.getPostView(this.state.currentId)}
              />),
              DATA: (this.renderView())
            }[this.state.viewStatus]}
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleViewModal}>Vissza</Button>
          </ModalFooter>
        </Modal>
        {this.state.modalForm &&
          <BlogForm
            {...this.props}
            id={this.state.currentId}
            setId={(id, callback) => {
              this.setState({currentId: id}, () => callback?.(id))}
            }
            modositas={!!this.state.currentId}
            showModalForm={this.state.modalForm}
            toggleShowModalForm={this.toggleFormModal}
          />
        }
    </React.Fragment>
    );
  }

  render = () => {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            <Button className="pull-left table-new-button" color="primary" onClick={() => this.setState({modalForm: true})}>
              {'Új bejegyzés'}
            </Button>
          </div>
          {this.renderTableView()}
        </div>
        {this.renderModals()}
      </React.Fragment>
    );
  }
}

BlogContent.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object
};

export default BlogContent;
